import { LazyMotion, domAnimation, m, AnimatePresence } from "framer-motion";
import { useState } from "react";
import Icon from "../../../general-ui/icon";
import { COLORS, ICONS } from "../../../general-ui/icon";
import ModalComponent from "../../../general-ui/modal/modal";
import languageMap from '../../../../utils/translate-langs-map.json';
import './read-only-indicator.scss';
import { useParams } from "react-router";

const ReadOnlyIndicator = ({ isOn, defaultLanguage }: { isOn: boolean, defaultLanguage?: string }) => {
	const [infoModalOpen, setInfoModalOpen] = useState(false);
	const { language } = useParams() as { language: string };

	const close = () => {
		setInfoModalOpen(false);
	};

	const open = () => {
		setInfoModalOpen(true);
	};

	const langMap = languageMap as Record<string, string>;

	return (
		<>
			<AnimatePresence>
				{isOn && (
					<LazyMotion features={domAnimation}>
						<m.div
							className="read-only-view"
							initial={{ translateX: 100, opacity: 0 }}
							animate={{ translateX: 0, opacity: 1 }}
							exit={{ translateX: 100, opacity: 0 }}
						>
							<h6>Read-only <span onClick={open}><Icon name={ICONS.INFO_CIRCLE} color={'black'} size={14} /></span></h6>
						</m.div>
					</LazyMotion>
				)}
			</AnimatePresence>
			<ModalComponent
				onRequestClose={close}
				open={infoModalOpen}
				cancellable
				closeable
				size="small"
			>
				<div className="read-only-modal">
					<p>This page cannot be edited because it is in <strong>{langMap[language]}.</strong></p>
					<p>To edit page content please go back to the event's default language<strong>{defaultLanguage ? ` ${langMap[defaultLanguage]}` : ''}.</strong></p>
					<p>Non-default language translations can be handled by downloading the translation .xslx, making your edits, and then uploading the files in the Translations dialog.</p>
				</div>
			</ModalComponent>
		</>
	);
};

export default ReadOnlyIndicator;